export {};

export const LOG_TABLES = {
    LOG: "api_log",
    ERROR: "api_error",
};
